const path = "user";

export const FETCH_USER_REQUEST = `${path}/FETCH_USER_REQUEST`;
export const FETCH_USER_SUCCESS = `${path}/FETCH_USER_SUCCESS`;
export const FETCH_USER_FAILURE = `${path}/FETCH_USER_FAILURE`;
export const FETCH_USER_CANCEL = `${path}/FETCH_USER_CANCEL`;
export const CLEAR_USER = `${path}/CLEAR_USER`;
